import http from 'http/index';
import { cas3ApiRoute } from 'http/utility';
import { assessmentsFormatter } from './formatter';

export const getAssessments = () => http.get(
  cas3ApiRoute('/assessments'),
).then((res) => assessmentsFormatter(res.data.assessments));

export default getAssessments;
